import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the FilterUsersVerificationView.
 * @extends JetView
 */
export default class FilterUsersVerificationView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const button = {
            id: 'r4',
            rows: [
                {
                    margin: 10,
                    responsive: 'r4',
                    cols: [
                        {
                            view: 'template',
                            id: 'templateVerification',
                            onClick: {
                                /**
                                 * Sends an AJAX request for account verification.
                                 * @param {Event} ev - The event object.
                                 * @param {string} id - The ID of the clicked element.
                                 */
                                send: function (ev, id) {
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Setting content type for the request
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'Client/AccountVerificationAPI', // API endpoint
                                            {},
                                            {
                                                /**
                                                 * Handles error response from the AJAX request.
                                                 * @param {string} text - The response text.
                                                 * @param {Object} data - The response data.
                                                 * @param {XMLHttpRequest} XMLHttpRequest - The XMLHttpRequest object.
                                                 */
                                                error: function (text, data, XMLHttpRequest) {
                                                    webix.message({
                                                        title: _('¡Error!'), // Error title
                                                        type: 'alert-error', // Error message type
                                                        text: _('Ocurrio un error.'), // Error message text
                                                    });
                                                },
                                                /**
                                                 * Handles successful response from the AJAX request.
                                                 * @param {string} text - The response text.
                                                 * @param {Object} data - The response data.
                                                 * @param {XMLHttpRequest} XMLHttpRequest - The XMLHttpRequest object.
                                                 */
                                                success: function (text, data, XMLHttpRequest) {
                                                    var data = JSON.parse(text); // Parsing JSON response
                                                    if (!data.HasError) {
                                                        window.open(data.Data.url, '_blank'); // Open URL in a new tab if no error
                                                    } else {
                                                        if (data.CodeError != undefined) {
                                                            webix.message({
                                                                title: '¡Error!', // Error title
                                                                type: 'alert-error', // Error message type
                                                                text: _('ERROR' + data.CodeError.toString()), // Error message text
                                                            });
                                                        } else {
                                                            if (
                                                                data.AlertMessage != undefined &&
                                                                data.AlertMessage != 'f'
                                                            ) {
                                                                webix.message({
                                                                    text: _(data.AlertMessage), // Display alert message
                                                                    type: 'error', // Error message type
                                                                });
                                                            }
                                                        }
                                                    }
                                                },
                                            },
                                        );
                                },
                            },
                        },
                        {
                            view: 'label',
                            align: 'center',
                            label: _('Su cuenta ya fue verificada.'), // Label for verified account
                            minWidth: 200,
                            css: 'my-label-vc', // Custom CSS class
                            id: 'CV', // ID for the label
                            hidden: true, // Initially hidden
                        },
                        {
                            view: 'label',
                            align: 'center',
                            label: _('Su cuenta esta en proceso de validación.'), // Label for account in validation process
                            minWidth: 200,
                            css: 'my-label-vc', // Custom CSS class
                            id: 'CPV', // ID for the label
                            hidden: true, // Initially hidden
                        },
                    ],
                },
            ],
        };
        return {
            view: 'form',
            id: 'form', // ID for the form
            rows: [button], // Rows containing the button configuration
        };
    }

    /**
     * Initializes the view and sets the HTML content for the verification template.
     */
    init() {
        $$('templateVerification').setHTML(
            `<center>
                <br>
                <img src='https://images.virtualsoft.tech/m/msjT1667507441.png' width='50' height='50'><br>
                <p>Para continuar con la verificación de su cuenta, debe presionar en 'Verificar Cuenta', así procesaremos su solicitud para que pueda realizar sus retiros fácilmente (solo es necesario hacerlo una vez).</p>
                 <div style="text-align: center;">
                <button class='button-login send' id="send"
                style="
                background-color: #80c3af !important;
                color: white;
                padding: 14px 20px;
                margin: 8px 0;
                border: none;
                border-radius: 4px;
                cursor: pointer;">Verificar Cuenta
                </button>
            </center>`,
        ); // Setting HTML content for the verification template
    }
}

// FILE DOCUMENTED
